import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { EventTicketPackageProfileActivitiesEntity } from './event-ticket-package-profile-activities.models'
import { GbPaginatedResponse } from 'libs/shared/models/shared.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPackageProfileActivitiesApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  /**
   * Syncs an event ticket package profile activity by its uuid
   */
  syncActivity(urlName: string, activityUuid?: string): Observable<EventTicketPackageProfileActivitiesEntity> {
    return this.get<EventTicketPackageProfileActivitiesEntity>(
      `auctions/${urlName}/profile/event-ticket-packages/${activityUuid}/`,
    )
  }
}
